// This file should be pure data.

export const CONSTANTS = {
  "AI_HINTS": {
    "baked_potato": "Roast a potato to bring out its comfort.",
    "batter": "Whisk the usual suspects together for frying or flipping.",
    "bread": "Apply heat to dough to make a loaf.",
    "caramel": "Slow heat and sugar lead to golden sweetness.",
    "caramel_toast": "Drizzle sweetness on crisp bread.",
    "caviar_toast": "Elegant pearls crown simple bread.",
    "celestial_pasta": "Stardust and unicorn milk create heavenly noodles.",
    "cheese_curds": "Salt causes milk to separate into curds.",
    "cheese_jam_platter": "Savory meets sweet on a simple board.",
    "cheesy_fried_rice": "Cheese melts into hot fried rice.",
    "cheesy_fries": "Top your fries with something melty and rich.",
    "choco_rice_crunch": "Chocolate and rice make a crunchy snack.",
    "chocolate_fry_dip": "Salty fries dipped into cocoa comfort.",
    "chocolate_overload": "Double down on chocolate.",
    "chocolate_pastry": "Chocolate plus pastry equals decadence.",
    "chocolate_slush": "Chilled cocoa with icy crystals.",
    "coconut_curry": "Tropical coconut meets warming spices.",
    "cooked_egg": "Heat sets the egg into a breakfast staple.",
    "cooked_meat": "A little fire turns raw into savory.",
    "cooked_pasta": "Cook your noodles in hot water.",
    "cooked_rice": "Grains with water—classic preparation.",
    "cookie": "Bake your dough to get a cookie.",
    "cookie_dough": "Sweeten your dough for a treat.",
    "cookie_ice_cream_sandwich": "Stack ice cream between two cookies.",
    "creme_brulee": "Caramelize sweetness over a rich custard.",
    "crystal_soup": "Crystalline salt creates clear perfection.",
    "custard": "Thicken sweet cream with an egg.",
    "diluted_milk": "Water down milk for a lighter dairy base.",
    "divine_pizza": "Mythical ingredients make godly pizza.",
    "dough": "Combine a dry base with water to start many baked goods.",
    "dragon_fruit_tart": "Mystical fruit in delicate pastry.",
    "egg_fried_rice": "Enrich your fried rice with an egg.",
    "enchanted_bread": "Herbs and magic transform simple bread.",
    "fancy_hot_chocolate": "Crown your cocoa with something fluffy.",
    "filled_pastry": "Pastry loves a fruity filling.",
    "foam": "A light, airy texture born from a dramatic reaction.",
    "fresh_pasta": "Enrich dough with egg to make noodles.",
    "fried_rice": "Toss cooked grains with protein for a hearty skillet dish.",
    "fries": "A starchy vegetable loves a hot bath in oil.",
    "fruit_pancakes": "Fold fruit into your batter for a sweet twist.",
    "fruit_rice_pudding": "Fresh fruit elevates a creamy classic.",
    "garlic_aioli": "Garlic transforms mayo into gourmet sauce.",
    "garlic_bread": "Bread, oil, and heat conjure a garlicky classic.",
    "gourmet_fries": "Fries dressed up with a house sauce.",
    "hawaiian_pizza": "A fruity topping turns pizza tropical.",
    "herb_butter": "Fresh herbs elevate simple butter.",
    "honey_glazed_salmon": "Sweet honey complements rich fish.",
    "honey_glazed_wagyu": "Sweet glaze on perfect beef.",
    "hot_chocolate": "Melt sweetness into warm milk for comfort.",
    "hot_oil": "Heat the oil to transform texture quickly.",
    "instagram_food": "Shiny and viral, if not always tasty.",
    "jam": "Sweet fruit preserves come from fruit and sugar.",
    "ketchup": "Sweeten and season your tomato juice for a classic condiment.",
    "ketchup_foam": "Classic condiment, reimagined.",
    "lasagna_sauce": "Combine sauce, meat, and cheese for a layered classic.",
    "lemon_risotto": "Citrus brightens creamy rice.",
    "loaded_fries": "Top cheesy fries with something crispy from the skillet.",
    "loaded_potato": "Top your baked potato with something melty.",
    "mac_and_cheese": "Cheese and pasta, creamy comfort.",
    "magical_feast": "Three magical ingredients create ultimate dish.",
    "margherita_pizza": "A simple pizza with cheese and sauce.",
    "mashed_potato": "Boil and mash to creamy perfection.",
    "mayonnaise": "Emulsify egg with oil for a creamy condiment.",
    "meat_lovers_pizza": "Stack meat with classic pizza flavors.",
    "meat_pizza": "Upgrade a classic pie with savory protein.",
    "meat_rice_bowl": "Add protein to a bowl of warm rice.",
    "mexican_mole_base": "Chocolate's savory side.",
    "minty_fresh_bread": "Not recommended by chefs—only dentists.",
    "mocha": "Chocolate and coffee-inspired warmth.",
    "mole_sauce": "Cocoa adds depth and sweetness to savory dishes.",
    "moonwater_soup": "Ethereal liquid makes mystical broth.",
    "oiled_pasta": "Finish pasta with a touch of oil.",
    "oven": "Harness fire and water to create controlled heat.",
    "pancake_sundae": "Ice cream tops warm pancakes.",
    "pancakes": "Cook batter into fluffy cakes.",
    "party_platter": "Pair a slice with a salty side to feed a crowd.",
    "pasta": "Enrich your dough with something from the henhouse.",
    "pastry": "Bake a sweetened dough for a flaky treat.",
    "phoenix_fire_stew": "Blazing mythical stew.",
    "phoenix_omelette": "Legendary egg creates fiery breakfast.",
    "pickle": "Salt and water transform fruit into a briny bite.",
    "pierogi": "Wrap a starchy filling with dough for a comforting dumpling.",
    "pizza": "Flatbread plus cheese becomes a classic pie.",
    "pizza_base": "Tomato and cheese form a classic foundation.",
    "pizza_sundae": "A wild mashup of hot and cold.",
    "pregnancy_craving": "An infamous combo for adventurous palates.",
    "rice_pizza": "A playful fusion of crust and grains.",
    "rice_pudding": "Sweeten rice with dairy for dessert.",
    "saffron_risotto": "Golden spice creates royal rice.",
    "salted_caramel": "A pinch of salt deepens caramel's flavor.",
    "sandwich": "Nestle cooked meat between slices.",
    "spaghett_cream": "Noodles with a frozen twist.",
    "spaghetti": "Dress your noodles with a bright red sauce.",
    "spaghetti_bolognese": "Give your pasta a hearty meaty sauce.",
    "spaghetti_marinara": "Dress cooked pasta in a bright tomato sauce.",
    "special_sauce": "Two condiments make something more.",
    "special_sauce_foam": "A modernist take on a diner favorite.",
    "stardust_cake": "Celestial powder creates cosmic dessert.",
    "stew": "Hearty combo: protein and tubers simmer well together.",
    "sweet_cream": "Dairy and sweetness make a delicious base.",
    "sweet_milk": "Sweeten warmed milk for a cozy drink.",
    "sweet_pizza": "Spread preserves on a slice for dessert.",
    "sweet_potato_madness": "Sweet dough meets salty crisp.",
    "sweet_salty_combo": "Cold meets crispy—unexpectedly good.",
    "sweet_salty_fries": "Custard adds a creamy twist to fries.",
    "sweet_savory_delight": "Sweet jam, rich chocolate, and savory cheese.",
    "toast_with_jam": "Jam loves a slice of bread, tomato bread works too.",
    "tomato_bread": "Work some tomato into dough for a savory loaf.",
    "tomato_foam": "A fancy twist on tomato flavor.",
    "tomato_gelato": "Tomato goes sweet and cold.",
    "tomato_juice": "Squeeze out the essence of tomatoes.",
    "tomato_sauce": "Cook tomatoes with sweetness to build a sauce.",
    "tomato_toast": "A simple topping makes bread sing.",
    "toothpaste": "Mint paste creation.",
    "truffle_pasta": "Luxury mushrooms make pasta extraordinary.",
    "unicorn_dream_cake": "Magical ingredients create dreamy dessert.",
    "unicorn_latte": "Magical milk makes dreamy drink.",
    "vanilla_panna_cotta": "Vanilla bean creates silky dessert.",
    "wagyu_steak": "Premium beef needs only fire.",
    "warm_milk": "Apply heat gently to milk.",
    "water": "The universal solvent.",
    "whipped_cream": "Add air or more dairy to make it fluffy."
  },
  "BASE_INGREDIENTS": [
    "water",
    "flour",
    "egg",
    "sugar",
    "milk",
    "rice",
    "tomato",
    "potato",
    "meat",
    "cheese",
    "oil",
    "chocolate",
    "fruit",
    "salt",
    "fire",
    "ice",
    "bacon",
    "air",
    "herbs",
    "spices",
    "garlic",
    "onion",
    "lemon",
    "honey",
    "truffle",
    "saffron",
    "caviar",
    "wagyu",
    "vanilla",
    "coconut",
    "dragon_fruit",
    "phoenix_egg",
    "unicorn_milk",
    "stardust",
    "moonwater",
    "crystal_salt"
  ],
  "COMBINATION_DISTANCE": 42,
  "COOKBOOK_CARD_HEIGHT": 200,
  "COOKBOOK_CARD_WIDTH": 320,
  "COOKBOOK_CATEGORIES": {
    "advanced": {
      "color": "#6366f1",
      "name": "Advanced Cooking",
      "order": 9
    },
    "basics": {
      "color": "#10b981",
      "name": "Basic Preparations",
      "order": 1
    },
    "breads": {
      "color": "#f59e0b",
      "name": "Breads & Dough",
      "order": 2
    },
    "dairy": {
      "color": "#06b6d4",
      "name": "Dairy & Cream",
      "order": 6
    },
    "exotic": {
      "color": "#7c3aed",
      "name": "Exotic Delicacies",
      "order": 13
    },
    "experimental": {
      "color": "#64748b",
      "name": "Experimental",
      "order": 11
    },
    "gourmet": {
      "color": "#d97706",
      "name": "Gourmet Cuisine",
      "order": 12
    },
    "magical": {
      "color": "#be185d",
      "name": "Magical Creations",
      "order": 14
    },
    "meat": {
      "color": "#dc2626",
      "name": "Meat & Protein",
      "order": 5
    },
    "molecular": {
      "color": "#a855f7",
      "name": "Molecular Gastronomy",
      "order": 10
    },
    "pasta": {
      "color": "#ef4444",
      "name": "Pasta & Noodles",
      "order": 3
    },
    "rice": {
      "color": "#8b5cf6",
      "name": "Rice Dishes",
      "order": 4
    },
    "sauces": {
      "color": "#f97316",
      "name": "Sauces & Condiments",
      "order": 8
    },
    "sweets": {
      "color": "#ec4899",
      "name": "Sweets & Desserts",
      "order": 7
    }
  },
  "COOKBOOK_COLUMNS": 3,
  "COOKBOOK_OVERSCAN_COUNT": 5,
  "COOKBOOK_SIDEBAR_DEFAULT_WIDTH": 256,
  "COOKBOOK_SIDEBAR_MAX_WIDTH": 400,
  "COOKBOOK_SIDEBAR_MIN_WIDTH": 200,
  "DAY_SYSTEM": {
    "DAY_DURATION_MS": 200000,
    "ORDERS_PER_DAY": 8,
    "ORDER_INTERVAL_MS": 25000,
    "TUTORIAL_RECIPES_TO_DISCOVER": 5
  },
  "DRAG_FEEDBACK": {
    "INVENTORY_DELETE_BORDER_COLOR": "#ef4444",
    "INVENTORY_DELETE_HIGHLIGHT_COLOR": "#dc2626",
    "INVENTORY_DELETE_HIGHLIGHT_OPACITY": 0.3
  },
  "GAME_SETTINGS": {
    "BASE_RECIPE_VALUE": 10,
    "SERVING_INTERVAL_MS": 30000,
    "TIP_BONUS_PER_INGREDIENT": 2
  },
  "INITIAL_MATERIALS": [
    "water",
    "flour",
    "egg",
    "sugar",
    "milk",
    "rice",
    "tomato",
    "potato",
    "meat",
    "cheese",
    "oil",
    "chocolate",
    "fruit",
    "salt",
    "fire",
    "ice"
  ],
  "INVENTORY_DEFAULT_WIDTH": 380,
  "INVENTORY_GRID_MIN_COL_WIDTH": 120,
  "INVENTORY_ITEM_HEIGHT": 44,
  "INVENTORY_MAX_WIDTH": 600,
  "INVENTORY_MIN_WIDTH": 280,
  "LOADING": {
    "DURATION_MS": 2000,
    "LOADING_TEXTS": [
      "Preparing ingredients...",
      "Heating up the kitchen...",
      "Sharpening knives...",
      "Organizing recipes...",
      "Starting the ovens..."
    ],
    "SPINNER_ROTATION_SPEED": 360
  },
  "MATERIALS": {
    "air": {
      "category": "basic",
      "icon": "🌬️",
      "id": "air",
      "name": "Air"
    },
    "bacon": {
      "category": "basic",
      "icon": "🥓",
      "id": "bacon",
      "name": "Bacon"
    },
    "bacon_cookie": {
      "category": "component",
      "icon": "🥓",
      "id": "bacon_cookie",
      "name": "Bacon Cookie"
    },
    "baked_potato": {
      "category": "component",
      "icon": "🥔",
      "id": "baked_potato",
      "name": "Baked Potato"
    },
    "batter": {
      "category": "component",
      "icon": "🥣",
      "id": "batter",
      "name": "Batter"
    },
    "bread": {
      "category": "component",
      "icon": "🍞",
      "id": "bread",
      "name": "Bread"
    },
    "caramel": {
      "category": "component",
      "icon": "🍯",
      "id": "caramel",
      "name": "Caramel"
    },
    "caramel_toast": {
      "category": "component",
      "icon": "🍞",
      "id": "caramel_toast",
      "name": "Caramel Toast"
    },
    "caviar": {
      "category": "basic",
      "icon": "🥚",
      "id": "caviar",
      "name": "Caviar"
    },
    "caviar_toast": {
      "category": "component",
      "icon": "🍞",
      "id": "caviar_toast",
      "name": "Caviar Toast"
    },
    "celestial_pasta": {
      "category": "component",
      "icon": "🍝",
      "id": "celestial_pasta",
      "name": "Celestial Pasta"
    },
    "cheese": {
      "category": "basic",
      "icon": "🧀",
      "id": "cheese",
      "name": "Cheese"
    },
    "cheese_curds": {
      "category": "component",
      "icon": "🧀",
      "id": "cheese_curds",
      "name": "Cheese Curds"
    },
    "cheese_jam_platter": {
      "category": "component",
      "icon": "🧀",
      "id": "cheese_jam_platter",
      "name": "Cheese & Jam Platter"
    },
    "cheesy_fried_rice": {
      "category": "component",
      "icon": "🍛",
      "id": "cheesy_fried_rice",
      "name": "Cheesy Fried Rice"
    },
    "cheesy_fries": {
      "category": "component",
      "icon": "🍟",
      "id": "cheesy_fries",
      "name": "Cheesy Fries"
    },
    "choco_rice_crunch": {
      "category": "component",
      "icon": "🍫",
      "id": "choco_rice_crunch",
      "name": "Choco Rice Crunch"
    },
    "chocolate": {
      "category": "basic",
      "icon": "🍫",
      "id": "chocolate",
      "name": "Chocolate"
    },
    "chocolate_fry_dip": {
      "category": "component",
      "icon": "🍟",
      "id": "chocolate_fry_dip",
      "name": "Chocolate Fry Dip"
    },
    "chocolate_overload": {
      "category": "component",
      "icon": "🍫",
      "id": "chocolate_overload",
      "name": "Chocolate Overload"
    },
    "chocolate_pastry": {
      "category": "component",
      "icon": "🍫",
      "id": "chocolate_pastry",
      "name": "Chocolate Pastry"
    },
    "chocolate_slush": {
      "category": "component",
      "icon": "🥤",
      "id": "chocolate_slush",
      "name": "Chocolate Slush"
    },
    "coconut": {
      "category": "basic",
      "icon": "🥥",
      "id": "coconut",
      "name": "Coconut"
    },
    "coconut_curry": {
      "category": "component",
      "icon": "🍛",
      "id": "coconut_curry",
      "name": "Coconut Curry"
    },
    "cold_water": {
      "category": "component",
      "icon": "💧",
      "id": "cold_water",
      "name": "Cold Water"
    },
    "cooked_egg": {
      "category": "component",
      "icon": "🍳",
      "id": "cooked_egg",
      "name": "Cooked Egg"
    },
    "cooked_meat": {
      "category": "component",
      "icon": "🍖",
      "id": "cooked_meat",
      "name": "Cooked Meat"
    },
    "cooked_pasta": {
      "category": "component",
      "icon": "🍝",
      "id": "cooked_pasta",
      "name": "Cooked Pasta"
    },
    "cooked_rice": {
      "category": "component",
      "icon": "🍚",
      "id": "cooked_rice",
      "name": "Cooked Rice"
    },
    "cookie": {
      "category": "component",
      "icon": "🍪",
      "id": "cookie",
      "name": "Cookie"
    },
    "cookie_dough": {
      "category": "component",
      "icon": "🍪",
      "id": "cookie_dough",
      "name": "Cookie Dough"
    },
    "cookie_ice_cream_sandwich": {
      "category": "component",
      "icon": "🍪",
      "id": "cookie_ice_cream_sandwich",
      "name": "Cookie Ice Cream Sandwich"
    },
    "creme_brulee": {
      "category": "component",
      "icon": "🍮",
      "id": "creme_brulee",
      "name": "Crème Brûlée"
    },
    "crystal_salt": {
      "category": "basic",
      "icon": "💎",
      "id": "crystal_salt",
      "name": "Crystal Salt"
    },
    "crystal_soup": {
      "category": "component",
      "icon": "🍲",
      "id": "crystal_soup",
      "name": "Crystal Soup"
    },
    "custard": {
      "category": "component",
      "icon": "🍮",
      "id": "custard",
      "name": "Custard"
    },
    "diluted_milk": {
      "category": "component",
      "icon": "🥛",
      "id": "diluted_milk",
      "name": "Diluted Milk"
    },
    "divine_pizza": {
      "category": "component",
      "icon": "🍕",
      "id": "divine_pizza",
      "name": "Divine Pizza"
    },
    "dough": {
      "category": "component",
      "icon": "🫓",
      "id": "dough",
      "name": "Dough"
    },
    "dragon_fruit": {
      "category": "basic",
      "icon": "🐉",
      "id": "dragon_fruit",
      "name": "Dragon Fruit"
    },
    "dragon_fruit_tart": {
      "category": "component",
      "icon": "🥧",
      "id": "dragon_fruit_tart",
      "name": "Dragon Fruit Tart"
    },
    "egg": {
      "category": "basic",
      "icon": "🥚",
      "id": "egg",
      "name": "Egg"
    },
    "egg_fried_rice": {
      "category": "component",
      "icon": "🍳",
      "id": "egg_fried_rice",
      "name": "Egg Fried Rice"
    },
    "enchanted_bread": {
      "category": "component",
      "icon": "🍞",
      "id": "enchanted_bread",
      "name": "Enchanted Bread"
    },
    "fancy_hot_chocolate": {
      "category": "component",
      "icon": "☕️",
      "id": "fancy_hot_chocolate",
      "name": "Fancy Hot Chocolate"
    },
    "filled_pastry": {
      "category": "component",
      "icon": "🥐",
      "id": "filled_pastry",
      "name": "Filled Pastry"
    },
    "fire": {
      "category": "basic",
      "icon": "🔥",
      "id": "fire",
      "name": "Fire"
    },
    "flour": {
      "category": "basic",
      "icon": "🌾",
      "id": "flour",
      "name": "Flour"
    },
    "foam": {
      "category": "advanced",
      "icon": "🫧",
      "id": "foam",
      "name": "Foam"
    },
    "fresh_pasta": {
      "category": "component",
      "icon": "🍝",
      "id": "fresh_pasta",
      "name": "Fresh Pasta"
    },
    "fried_rice": {
      "category": "component",
      "icon": "🍛",
      "id": "fried_rice",
      "name": "Fried Rice"
    },
    "fries": {
      "category": "component",
      "icon": "🍟",
      "id": "fries",
      "name": "Fries"
    },
    "fruit": {
      "category": "basic",
      "icon": "🍓",
      "id": "fruit",
      "name": "Fruit"
    },
    "fruit_pancakes": {
      "category": "component",
      "icon": "🥞",
      "id": "fruit_pancakes",
      "name": "Fruit Pancakes"
    },
    "fruit_rice_pudding": {
      "category": "component",
      "icon": "🍮",
      "id": "fruit_rice_pudding",
      "name": "Fruit Rice Pudding"
    },
    "garlic": {
      "category": "basic",
      "icon": "🧄",
      "id": "garlic",
      "name": "Garlic"
    },
    "garlic_aioli": {
      "category": "component",
      "icon": "🫙",
      "id": "garlic_aioli",
      "name": "Garlic Aioli"
    },
    "garlic_bread": {
      "category": "component",
      "icon": "🍞",
      "id": "garlic_bread",
      "name": "Garlic Bread"
    },
    "glitter": {
      "category": "advanced",
      "icon": "✨",
      "id": "glitter",
      "name": "Glitter"
    },
    "gourmet_fries": {
      "category": "component",
      "icon": "🍟",
      "id": "gourmet_fries",
      "name": "Gourmet Fries"
    },
    "hawaiian_pizza": {
      "category": "component",
      "icon": "🍍",
      "id": "hawaiian_pizza",
      "name": "Hawaiian Pizza"
    },
    "herb_butter": {
      "category": "component",
      "icon": "🧈",
      "id": "herb_butter",
      "name": "Herb Butter"
    },
    "herbs": {
      "category": "basic",
      "icon": "🌿",
      "id": "herbs",
      "name": "Herbs"
    },
    "honey": {
      "category": "basic",
      "icon": "🍯",
      "id": "honey",
      "name": "Honey"
    },
    "honey_glazed_salmon": {
      "category": "component",
      "icon": "🐟",
      "id": "honey_glazed_salmon",
      "name": "Honey Glazed Salmon"
    },
    "honey_glazed_wagyu": {
      "category": "component",
      "icon": "🥩",
      "id": "honey_glazed_wagyu",
      "name": "Honey Glazed Wagyu"
    },
    "hot_chocolate": {
      "category": "component",
      "icon": "☕️",
      "id": "hot_chocolate",
      "name": "Hot Chocolate"
    },
    "hot_oil": {
      "category": "component",
      "icon": "🫒",
      "id": "hot_oil",
      "name": "Hot Oil"
    },
    "ice": {
      "category": "basic",
      "icon": "🧊",
      "id": "ice",
      "name": "Ice"
    },
    "ice_cream": {
      "category": "component",
      "icon": "🍨",
      "id": "ice_cream",
      "name": "Ice Cream"
    },
    "instagram_food": {
      "category": "advanced",
      "icon": "✨",
      "id": "instagram_food",
      "name": "Instagram Food"
    },
    "jam": {
      "category": "component",
      "icon": "🍓",
      "id": "jam",
      "name": "Jam"
    },
    "ketchup": {
      "category": "component",
      "icon": "🫙",
      "id": "ketchup",
      "name": "Ketchup"
    },
    "ketchup_foam": {
      "category": "molecular",
      "icon": "🫧",
      "id": "ketchup_foam",
      "name": "Ketchup Foam"
    },
    "lasagna_sauce": {
      "category": "component",
      "icon": "🫙",
      "id": "lasagna_sauce",
      "name": "Lasagna Sauce"
    },
    "lemon": {
      "category": "basic",
      "icon": "🍋",
      "id": "lemon",
      "name": "Lemon"
    },
    "lemon_risotto": {
      "category": "component",
      "icon": "🍋",
      "id": "lemon_risotto",
      "name": "Lemon Risotto"
    },
    "loaded_fries": {
      "category": "component",
      "icon": "🍟",
      "id": "loaded_fries",
      "name": "Loaded Fries"
    },
    "loaded_potato": {
      "category": "component",
      "icon": "🥔",
      "id": "loaded_potato",
      "name": "Loaded Potato"
    },
    "mac_and_cheese": {
      "category": "component",
      "icon": "🍝",
      "id": "mac_and_cheese",
      "name": "Mac and Cheese"
    },
    "magical_feast": {
      "category": "component",
      "icon": "🍽️",
      "id": "magical_feast",
      "name": "Magical Feast"
    },
    "margherita_pizza": {
      "category": "component",
      "icon": "🍕",
      "id": "margherita_pizza",
      "name": "Margherita Pizza"
    },
    "mashed_potato": {
      "category": "component",
      "icon": "🥔",
      "id": "mashed_potato",
      "name": "Mashed Potato"
    },
    "mayonnaise": {
      "category": "component",
      "icon": "🫙",
      "id": "mayonnaise",
      "name": "Mayonnaise"
    },
    "meat": {
      "category": "basic",
      "icon": "🥩",
      "id": "meat",
      "name": "Meat"
    },
    "meat_lovers_pizza": {
      "category": "component",
      "icon": "🍕",
      "id": "meat_lovers_pizza",
      "name": "Meat Lover's Pizza"
    },
    "meat_pizza": {
      "category": "component",
      "icon": "🍕",
      "id": "meat_pizza",
      "name": "Meat Pizza"
    },
    "meat_rice_bowl": {
      "category": "component",
      "icon": "🍛",
      "id": "meat_rice_bowl",
      "name": "Meat Rice Bowl"
    },
    "mexican_mole_base": {
      "category": "component",
      "icon": "🍫",
      "id": "mexican_mole_base",
      "name": "Mexican Mole Base"
    },
    "milk": {
      "category": "basic",
      "icon": "🥛",
      "id": "milk",
      "name": "Milk"
    },
    "mint": {
      "category": "basic",
      "icon": "🌿",
      "id": "mint",
      "name": "Mint"
    },
    "minty_fresh_bread": {
      "category": "component",
      "icon": "🍞",
      "id": "minty_fresh_bread",
      "name": "Minty Fresh Bread"
    },
    "mocha": {
      "category": "component",
      "icon": "☕️",
      "id": "mocha",
      "name": "Mocha"
    },
    "mole_sauce": {
      "category": "component",
      "icon": "🍫",
      "id": "mole_sauce",
      "name": "Mole Sauce"
    },
    "moonwater": {
      "category": "basic",
      "icon": "🌙",
      "id": "moonwater",
      "name": "Moonwater"
    },
    "moonwater_soup": {
      "category": "component",
      "icon": "🍲",
      "id": "moonwater_soup",
      "name": "Moonwater Soup"
    },
    "oil": {
      "category": "basic",
      "icon": "🫒",
      "id": "oil",
      "name": "Oil"
    },
    "oiled_pasta": {
      "category": "component",
      "icon": "🍝",
      "id": "oiled_pasta",
      "name": "Oiled Pasta"
    },
    "onion": {
      "category": "basic",
      "icon": "🧅",
      "id": "onion",
      "name": "Onion"
    },
    "oven": {
      "category": "advanced",
      "icon": "♨️",
      "id": "oven",
      "name": "Oven"
    },
    "pancake_sundae": {
      "category": "component",
      "icon": "🍨",
      "id": "pancake_sundae",
      "name": "Pancake Sundae"
    },
    "pancakes": {
      "category": "component",
      "icon": "🥞",
      "id": "pancakes",
      "name": "Pancakes"
    },
    "party_platter": {
      "category": "component",
      "icon": "🍽️",
      "id": "party_platter",
      "name": "Party Platter"
    },
    "pasta": {
      "category": "component",
      "icon": "🍝",
      "id": "pasta",
      "name": "Pasta"
    },
    "paste": {
      "category": "basic",
      "icon": "🧴",
      "id": "paste",
      "name": "Paste"
    },
    "pastry": {
      "category": "component",
      "icon": "🥐",
      "id": "pastry",
      "name": "Pastry"
    },
    "peanut_butter": {
      "category": "basic",
      "icon": "🥜",
      "id": "peanut_butter",
      "name": "Peanut Butter"
    },
    "phoenix_egg": {
      "category": "basic",
      "icon": "🔥",
      "id": "phoenix_egg",
      "name": "Phoenix Egg"
    },
    "phoenix_fire_stew": {
      "category": "component",
      "icon": "🔥",
      "id": "phoenix_fire_stew",
      "name": "Phoenix Fire Stew"
    },
    "phoenix_omelette": {
      "category": "component",
      "icon": "🍳",
      "id": "phoenix_omelette",
      "name": "Phoenix Omelette"
    },
    "pickle": {
      "category": "component",
      "icon": "🥒",
      "id": "pickle",
      "name": "Pickle"
    },
    "pierogi": {
      "category": "component",
      "icon": "🥟",
      "id": "pierogi",
      "name": "Pierogi"
    },
    "pizza": {
      "category": "component",
      "icon": "🍕",
      "id": "pizza",
      "name": "Pizza"
    },
    "pizza_base": {
      "category": "component",
      "icon": "🍕",
      "id": "pizza_base",
      "name": "Pizza Base"
    },
    "pizza_sundae": {
      "category": "component",
      "icon": "🍕",
      "id": "pizza_sundae",
      "name": "Pizza Sundae"
    },
    "potato": {
      "category": "basic",
      "icon": "🥔",
      "id": "potato",
      "name": "Potato"
    },
    "pregnancy_craving": {
      "category": "component",
      "icon": "🤰",
      "id": "pregnancy_craving",
      "name": "Pregnancy Craving"
    },
    "pressure": {
      "category": "advanced",
      "icon": "🗜️",
      "id": "pressure",
      "name": "Pressure"
    },
    "rice": {
      "category": "basic",
      "icon": "🍚",
      "id": "rice",
      "name": "Rice"
    },
    "rice_pizza": {
      "category": "component",
      "icon": "🍕",
      "id": "rice_pizza",
      "name": "Rice Pizza"
    },
    "rice_pudding": {
      "category": "component",
      "icon": "🍮",
      "id": "rice_pudding",
      "name": "Rice Pudding"
    },
    "saffron": {
      "category": "basic",
      "icon": "🌾",
      "id": "saffron",
      "name": "Saffron"
    },
    "saffron_risotto": {
      "category": "component",
      "icon": "🍛",
      "id": "saffron_risotto",
      "name": "Saffron Risotto"
    },
    "salt": {
      "category": "basic",
      "icon": "🧂",
      "id": "salt",
      "name": "Salt"
    },
    "salted_caramel": {
      "category": "component",
      "icon": "🍯",
      "id": "salted_caramel",
      "name": "Salted Caramel"
    },
    "sandwich": {
      "category": "component",
      "icon": "🥪",
      "id": "sandwich",
      "name": "Sandwich"
    },
    "smoke": {
      "category": "advanced",
      "icon": "💨",
      "id": "smoke",
      "name": "Smoke"
    },
    "spaghett_cream": {
      "category": "component",
      "icon": "🍝",
      "id": "spaghett_cream",
      "name": "Spaghett-cream"
    },
    "spaghetti": {
      "category": "component",
      "icon": "🍝",
      "id": "spaghetti",
      "name": "Spaghetti"
    },
    "spaghetti_bolognese": {
      "category": "component",
      "icon": "🍝",
      "id": "spaghetti_bolognese",
      "name": "Spaghetti Bolognese"
    },
    "spaghetti_marinara": {
      "category": "component",
      "icon": "🍝",
      "id": "spaghetti_marinara",
      "name": "Spaghetti Marinara"
    },
    "special_sauce": {
      "category": "component",
      "icon": "🫙",
      "id": "special_sauce",
      "name": "Special Sauce"
    },
    "special_sauce_foam": {
      "category": "molecular",
      "icon": "🫧",
      "id": "special_sauce_foam",
      "name": "Special Sauce Foam"
    },
    "spices": {
      "category": "basic",
      "icon": "🌶️",
      "id": "spices",
      "name": "Spices"
    },
    "stardust": {
      "category": "basic",
      "icon": "✨",
      "id": "stardust",
      "name": "Stardust"
    },
    "stardust_cake": {
      "category": "component",
      "icon": "🎂",
      "id": "stardust_cake",
      "name": "Stardust Cake"
    },
    "steam": {
      "category": "advanced",
      "icon": "💨",
      "id": "steam",
      "name": "Steam"
    },
    "stew": {
      "category": "component",
      "icon": "🥘",
      "id": "stew",
      "name": "Stew"
    },
    "sugar": {
      "category": "basic",
      "icon": "🍬",
      "id": "sugar",
      "name": "Sugar"
    },
    "sweet_cream": {
      "category": "component",
      "icon": "🍨",
      "id": "sweet_cream",
      "name": "Sweet Cream"
    },
    "sweet_milk": {
      "category": "component",
      "icon": "🥛",
      "id": "sweet_milk",
      "name": "Sweet Milk"
    },
    "sweet_pizza": {
      "category": "component",
      "icon": "🍕",
      "id": "sweet_pizza",
      "name": "Sweet Pizza"
    },
    "sweet_potato_madness": {
      "category": "component",
      "icon": "🍠",
      "id": "sweet_potato_madness",
      "name": "Sweet Potato Madness"
    },
    "sweet_salty_combo": {
      "category": "component",
      "icon": "🍟",
      "id": "sweet_salty_combo",
      "name": "Sweet & Salty Combo"
    },
    "sweet_salty_fries": {
      "category": "component",
      "icon": "🍟",
      "id": "sweet_salty_fries",
      "name": "Sweet 'n' Salty Fries"
    },
    "sweet_savory_delight": {
      "category": "component",
      "icon": "🍫",
      "id": "sweet_savory_delight",
      "name": "Sweet & Savory Delight"
    },
    "time": {
      "category": "advanced",
      "icon": "⏳",
      "id": "time",
      "name": "Time"
    },
    "toast_with_jam": {
      "category": "component",
      "icon": "🍞",
      "id": "toast_with_jam",
      "name": "Toast with Jam"
    },
    "tomato": {
      "category": "basic",
      "icon": "🍅",
      "id": "tomato",
      "name": "Tomato"
    },
    "tomato_bread": {
      "category": "component",
      "icon": "🍞",
      "id": "tomato_bread",
      "name": "Tomato Bread"
    },
    "tomato_foam": {
      "category": "molecular",
      "icon": "🫧",
      "id": "tomato_foam",
      "name": "Tomato Foam"
    },
    "tomato_gelato": {
      "category": "component",
      "icon": "🍧",
      "id": "tomato_gelato",
      "name": "Tomato Gelato"
    },
    "tomato_juice": {
      "category": "component",
      "icon": "🧃",
      "id": "tomato_juice",
      "name": "Tomato Juice"
    },
    "tomato_sauce": {
      "category": "component",
      "icon": "🫙",
      "id": "tomato_sauce",
      "name": "Tomato Sauce"
    },
    "tomato_toast": {
      "category": "component",
      "icon": "🍞",
      "id": "tomato_toast",
      "name": "Tomato Toast"
    },
    "toothpaste": {
      "category": "component",
      "icon": "🪥",
      "id": "toothpaste",
      "name": "Toothpaste"
    },
    "truffle": {
      "category": "basic",
      "icon": "🍄",
      "id": "truffle",
      "name": "Truffle"
    },
    "truffle_pasta": {
      "category": "component",
      "icon": "🍝",
      "id": "truffle_pasta",
      "name": "Truffle Pasta"
    },
    "unicorn_dream_cake": {
      "category": "component",
      "icon": "🎂",
      "id": "unicorn_dream_cake",
      "name": "Unicorn Dream Cake"
    },
    "unicorn_latte": {
      "category": "component",
      "icon": "☕️",
      "id": "unicorn_latte",
      "name": "Unicorn Latte"
    },
    "unicorn_milk": {
      "category": "basic",
      "icon": "🦄",
      "id": "unicorn_milk",
      "name": "Unicorn Milk"
    },
    "vanilla": {
      "category": "basic",
      "icon": "🌿",
      "id": "vanilla",
      "name": "Vanilla"
    },
    "vanilla_panna_cotta": {

      "category": "gourmet",
      "description": "Silky vanilla dessert"
    },
    "wagyu": {
      "category": "basic",
      "icon": "🥩",
      "id": "wagyu",
      "name": "Wagyu Beef"
    },
    "wagyu_steak": {
      "category": "component",
      "icon": "🥩",
      "id": "wagyu_steak",
      "name": "Wagyu Steak"
    },
    "warm_milk": {
      "category": "component",
      "icon": "🥛",
      "id": "warm_milk",
      "name": "Warm Milk"
    },
    "water": {
      "category": "basic",
      "icon": "💧",
      "id": "water",
      "name": "Water"
    },
    "whipped_cream": {
      "category": "component",
      "icon": "🧁",
      "id": "whipped_cream",
      "name": "Whipped Cream"
    }
  },
  "MAX_ZOOM": 2.5,
  "MENU": {
    "DEFAULT_MUSIC_VOLUME": 75,
    "DEFAULT_SFX_VOLUME": 85
  },
  "MIN_ZOOM": 0.3,
  "MUSIC": {
    "VOLUME_FADE_DURATION_MS": 500
  },
  "ORDER_SYSTEM": {
    "CLEANUP_INTERVAL_MS": 1000,
    "TIMEOUT_MS": 20000
  },
  "POSSIBLE_ORDERS": [
    "bread",
    "spaghetti",
    "fries",
    "stew",
    "margherita_pizza",
    "mac_and_cheese",
    "sandwich",
    "pancakes",
    "hot_chocolate",
    "ice_cream",
    "cookie",
    "spaghetti_bolognese",
    "loaded_fries",
    "meat_lovers_pizza",
    "party_platter",
    "creme_brulee",
    "truffle_pasta",
    "dragon_fruit_tart",
    "phoenix_omelette",
    "unicorn_latte",
    "stardust_cake",
    "crystal_soup",
    "saffron_risotto",
    "caviar_toast",
    "honey_glazed_wagyu",
    "magical_feast"
  ],
  "RECIPES": {
    "air+sweet_cream": "whipped_cream",
    "bacon+cheesy_fries": "loaded_fries",
    "bacon+cookie": "bacon_cookie",
    "baked_potato+cheese": "loaded_potato",
    "batter+fire": "pancakes",
    "batter+fruit": "fruit_pancakes",
    "bread+caviar": "caviar_toast",
    "bread+cooked_meat": "sandwich",
    "bread+jam": "toast_with_jam",
    "bread+salted_caramel": "caramel_toast",
    "bread+tomato": "tomato_toast",
    "bread+tomato_sauce": "pizza_base",
    "bread+toothpaste": "minty_fresh_bread",
    "caramel+hot_chocolate": "mocha",
    "caramel+salt": "salted_caramel",
    "cheese+chocolate": "mexican_mole_base",
    "cheese+cooked_pasta": "mac_and_cheese",
    "cheese+fried_rice": "cheesy_fried_rice",
    "cheese+fries": "cheesy_fries",
    "cheese+jam": "cheese_jam_platter",
    "cheese+pizza_base": "margherita_pizza",
    "cheese+tomato": "pizza_base",
    "chocolate+cooked_rice": "choco_rice_crunch",
    "chocolate+cookie_dough": "chocolate_pastry",
    "chocolate+meat": "mole_sauce",
    "chocolate+pastry": "chocolate_pastry",
    "chocolate+rice": "choco_rice_crunch",
    "chocolate+warm_milk": "hot_chocolate",
    "coconut+spices": "coconut_curry",
    "cooked_egg+cooked_rice": "egg_fried_rice",
    "cooked_meat+cooked_rice": "meat_rice_bowl",
    "cooked_meat+margherita_pizza": "meat_pizza",
    "cooked_pasta+oil": "oiled_pasta",
    "cooked_pasta+tomato_sauce": "spaghetti_marinara",
    "cooked_rice+meat": "fried_rice",
    "cooked_rice+saffron": "saffron_risotto",
    "cookie+ice_cream": "cookie_ice_cream_sandwich",
    "cookie_dough+fire": "cookie",
    "cookie_dough+fries": "sweet_potato_madness",
    "cookie_dough+oven": "cookie",
    "crystal_salt+water": "crystal_soup",
    "custard+fries": "sweet_salty_fries",
    "custard+sugar": "creme_brulee",
    "dough+egg": "pasta",
    "dough+fire": "bread",
    "dough+oven": "bread",
    "dough+potato": "pierogi",
    "dough+sugar": "cookie_dough",
    "dough+tomato": "tomato_bread",
    "dragon_fruit+pastry": "dragon_fruit_tart",
    "egg+fire": "cooked_egg",
    "egg+fried_rice": "egg_fried_rice",
    "egg+oil": "mayonnaise",
    "egg+sweet_cream": "custard",
    "fire+meat": "cooked_meat",
    "fire+milk": "warm_milk",
    "fire+oil": "hot_oil",
    "fire+phoenix_egg": "phoenix_omelette",
    "fire+potato": "baked_potato",
    "fire+wagyu": "wagyu_steak",
    "fire+water": "oven",
    "flour+water": "dough",
    "foam+ketchup": "ketchup_foam",
    "foam+special_sauce": "special_sauce_foam",
    "foam+tomato_sauce": "tomato_foam",
    "fresh_pasta+fire": "cooked_pasta",
    "fries+glitter": "instagram_food",
    "fries+hot_chocolate": "chocolate_fry_dip",
    "fries+ice_cream": "sweet_salty_combo",
    "fries+pizza": "party_platter",
    "fries+special_sauce": "gourmet_fries",
    "fruit+pizza": "hawaiian_pizza",
    "fruit+rice_pudding": "fruit_rice_pudding",
    "garlic+mayonnaise": "garlic_aioli",
    "herbs+milk": "herb_butter",
    "honey+meat": "honey_glazed_salmon",
    "honey+wagyu_steak": "honey_glazed_wagyu",
    "hot_chocolate+chocolate_pastry": "chocolate_overload",
    "hot_chocolate+ice": "chocolate_slush",
    "hot_chocolate+unicorn_milk": "unicorn_latte",
    "hot_chocolate+whipped_cream": "fancy_hot_chocolate",
    "ice+water": "cold_water",
    "ice_cream+ketchup": "tomato_gelato",
    "ice_cream+pancakes": "pancake_sundae",
    "ice_cream+pasta": "spaghett_cream",
    "jam+pastry": "filled_pastry",
    "jam+pizza": "sweet_pizza",
    "jam+tomato_bread": "toast_with_jam",
    "ketchup+mayonnaise": "special_sauce",
    "lemon+cooked_rice": "lemon_risotto",
    "meat+potato": "stew",
    "meat+spaghetti": "spaghetti_bolognese",
    "milk+salt": "cheese_curds",
    "milk+sugar": "sweet_cream",
    "milk+sweet_cream": "whipped_cream",
    "milk+vanilla": "vanilla_panna_cotta",
    "milk+water": "diluted_milk",
    "mint+paste": "toothpaste",
    "moonwater+water": "moonwater_soup",
    "oil+potato": "fries",
    "oiled_pasta": "oiled_pasta",
    "pancakes+glitter": "instagram_food",
    "pasta+fire": "cooked_pasta",
    "pasta+tomato": "spaghetti",
    "pasta+truffle": "truffle_pasta",
    "pastry+stardust": "stardust_cake",
    "pizza+glitter": "instagram_food",
    "pizza+ice_cream": "pizza_sundae",
    "pizza_base+rice": "rice_pizza",
    "sandwich+glitter": "instagram_food",
    "sugar+sweet_cream": "ice_cream",
    "sugar+warm_milk": "sweet_milk",
    "tomato+water": "tomato_juice"
  },
  "RECIPE_METADATA": {
    "bacon_cookie": {
      "category": "experimental",
      "description": "Sweet and salty cookie"
    },
    "baked_potato": {
      "category": "advanced",
      "description": "Oven-roasted potato"
    },
    "batter": {
      "category": "basics",
      "description": "Perfect for pancakes and frying"
    },
    "bread": {
      "category": "breads",
      "description": "Classic baked loaf"
    },
    "caramel": {
      "category": "sweets",
      "description": "Golden caramelized sugar"
    },
    "caramel_toast": {
      "category": "breads",
      "description": "Sweet caramelized treat"
    },
    "caviar_toast": {
      "category": "gourmet",
      "description": "Elegant caviar canapé"
    },
    "celestial_pasta": {
      "category": "magical",
      "description": "Star-blessed noodles"
    },
    "cheese_curds": {
      "category": "dairy",
      "description": "Fresh cheese curds"
    },
    "cheese_jam_platter": {
      "category": "advanced",
      "description": "Sweet and savory board"
    },
    "cheesy_fried_rice": {
      "category": "rice",
      "description": "Melted cheese rice fusion"
    },
    "cheesy_fries": {
      "category": "advanced",
      "description": "Cheese-topped fries"
    },
    "choco_rice_crunch": {
      "category": "experimental",
      "description": "Chocolate rice cereal"
    },
    "chocolate_fry_dip": {
      "category": "experimental",
      "description": "Fries in hot chocolate"
    },
    "chocolate_overload": {
      "category": "sweets",
      "description": "Double chocolate dessert"
    },
    "chocolate_pastry": {
      "category": "sweets",
      "description": "Chocolate-filled pastry"
    },
    "chocolate_slush": {
      "category": "sweets",
      "description": "Icy chocolate drink"
    },
    "coconut_curry": {
      "category": "gourmet",
      "description": "Creamy coconut curry"
    },
    "cold_water": {
      "category": "molecular",
      "description": "Precisely chilled water"
    },
    "cooked_egg": {
      "category": "basics",
      "description": "Simple fried egg"
    },
    "cooked_meat": {
      "category": "basics",
      "description": "Properly cooked protein"
    },
    "cooked_pasta": {
      "category": "pasta",
      "description": "Al dente perfection"
    },
    "cooked_rice": {
      "category": "basics",
      "description": "Fluffy steamed rice"
    },
    "cookie": {
      "category": "sweets",
      "description": "Baked cookie perfection"
    },
    "cookie_dough": {
      "category": "sweets",
      "description": "Sweet cookie preparation"
    },
    "cookie_ice_cream_sandwich": {
      "category": "sweets",
      "description": "Ice cream between cookies"
    },
    "creme_brulee": {
      "category": "sweets",
      "description": "Caramelized custard dessert"
    },
    "crystal_soup": {
      "category": "exotic",
      "description": "Crystalline broth"
    },
    "custard": {
      "category": "dairy",
      "description": "Rich egg custard"
    },
    "diluted_milk": {
      "category": "dairy",
      "description": "Watered-down milk"
    },
    "divine_pizza": {
      "category": "magical",
      "description": "Heavenly pizza creation"
    },
    "dough": {
      "category": "basics",
      "description": "Foundation for many baked goods"
    },
    "dragon_fruit_tart": {
      "category": "exotic",
      "description": "Mystical fruit pastry"
    },
    "egg_fried_rice": {
      "category": "rice",
      "description": "Classic egg-enhanced fried rice"
    },
    "enchanted_bread": {
      "category": "magical",
      "description": "Magically enhanced loaf"
    },
    "fancy_hot_chocolate": {
      "category": "sweets",
      "description": "Whipped cream topped cocoa"
    },
    "filled_pastry": {
      "category": "sweets",
      "description": "Jam-filled pastry"
    },
    "foam": {
      "category": "molecular",
      "description": "Light molecular foam"
    },
    "fresh_pasta": {
      "category": "pasta",
      "description": "Egg-enriched pasta dough"
    },
    "fried_rice": {
      "category": "rice",
      "description": "Stir-fried rice with protein"
    },
    "fries": {
      "category": "advanced",
      "description": "Crispy fried potatoes"
    },
    "fruit_pancakes": {
      "category": "sweets",
      "description": "Fruit-studded pancakes"
    },
    "fruit_rice_pudding": {
      "category": "sweets",
      "description": "Fruit-enhanced rice pudding"
    },
    "garlic_aioli": {
      "category": "gourmet",
      "description": "Creamy garlic mayonnaise"
    },
    "garlic_bread": {
      "category": "breads",
      "description": "Aromatic side dish"
    },
    "gourmet_fries": {
      "category": "advanced",
      "description": "Upscale fries with sauce"
    },
    "hawaiian_pizza": {
      "category": "advanced",
      "description": "Fruit-topped pizza"
    },
    "herb_butter": {
      "category": "gourmet",
      "description": "Aromatic herb-infused butter"
    },
    "honey_glazed_salmon": {
      "category": "gourmet",
      "description": "Sweet and savory fish"
    },
    "honey_glazed_wagyu": {
      "category": "gourmet",
      "description": "Sweet glazed premium beef"
    },
    "hot_chocolate": {
      "category": "sweets",
      "description": "Warm chocolate drink"
    },
    "ice_cream": {
      "category": "dairy",
      "description": "Frozen sweet treat"
    },
    "instagram_food": {
      "category": "experimental",
      "description": "Glittery social media food"
    },
    "jam": {
      "category": "sweets",
      "description": "Sweet fruit preserve"
    },
    "ketchup": {
      "category": "sauces",
      "description": "Sweet tomato condiment"
    },
    "ketchup_foam": {
      "category": "molecular",
      "description": "Ketchup in foam form"
    },
    "lasagna_sauce": {
      "category": "sauces",
      "description": "Rich layered sauce"
    },
    "lemon_risotto": {
      "category": "gourmet",
      "description": "Citrus-infused rice dish"
    },
    "loaded_fries": {
      "category": "advanced",
      "description": "Fully loaded fries"
    },
    "loaded_potato": {
      "category": "advanced",
      "description": "Cheese-topped baked potato"
    },
    "mac_and_cheese": {
      "category": "pasta",
      "description": "Creamy comfort food"
    },
    "magical_feast": {
      "category": "magical",
      "description": "Ultimate magical banquet"
    },
    "margherita_pizza": {
      "category": "advanced",
      "description": "Classic Italian pizza"
    },
    "mashed_potato": {
      "category": "advanced",
      "description": "Creamy mashed potatoes"
    },
    "mayonnaise": {
      "category": "sauces",
      "description": "Creamy egg-oil emulsion"
    },
    "meat_lovers_pizza": {
      "category": "advanced",
      "description": "Multiple meat pizza"
    },
    "meat_pizza": {
      "category": "advanced",
      "description": "Protein-topped pizza"
    },
    "meat_rice_bowl": {
      "category": "rice",
      "description": "Hearty protein rice bowl"
    },
    "mexican_mole_base": {
      "category": "experimental",
      "description": "Chocolate-cheese fusion"
    },
    "minty_fresh_bread": {
      "category": "experimental",
      "description": "Questionable dental hygiene bread"
    },
    "mocha": {
      "category": "sweets",
      "description": "Chocolate coffee drink"
    },
    "mole_sauce": {
      "category": "sauces",
      "description": "Complex chocolate sauce"
    },
    "moonwater_soup": {
      "category": "exotic",
      "description": "Ethereal liquid dish"
    },
    "oiled_pasta": {
      "category": "pasta",
      "description": "Simple oil-dressed noodles"
    },
    "pancake_sundae": {
      "category": "sweets",
      "description": "Ice cream topped pancakes"
    },
    "pancakes": {
      "category": "sweets",
      "description": "Fluffy breakfast cakes"
    },
    "party_platter": {
      "category": "advanced",
      "description": "Pizza and fries combo"
    },
    "pasta": {
      "category": "pasta",
      "description": "Fresh homemade noodles"
    },
    "pastry": {
      "category": "sweets",
      "description": "Flaky baked pastry"
    },
    "phoenix_fire_stew": {
      "category": "magical",
      "description": "Blazing mythical stew"
    },
    "phoenix_omelette": {
      "category": "exotic",
      "description": "Legendary egg dish"
    },
    "pierogi": {
      "category": "advanced",
      "description": "Stuffed potato dumplings"
    },
    "pizza_base": {
      "category": "advanced",
      "description": "Foundation for pizza"
    },
    "pizza_sundae": {
      "category": "experimental",
      "description": "Pizza meets ice cream"
    },
    "pregnancy_craving": {
      "category": "experimental",
      "description": "Pickle and peanut butter"
    },
    "rice_pizza": {
      "category": "experimental",
      "description": "Fusion rice-crust pizza"
    },
    "rice_pudding": {
      "category": "sweets",
      "description": "Creamy sweet rice dessert"
    },
    "saffron_risotto": {
      "category": "gourmet",
      "description": "Golden saffron rice"
    },
    "salted_caramel": {
      "category": "sweets",
      "description": "Sweet and salty caramel"
    },
    "sandwich": {
      "category": "meat",
      "description": "Classic meat sandwich"
    },
    "spaghett_cream": {
      "category": "experimental",
      "description": "Frozen pasta experiment"
    },
    "spaghetti": {
      "category": "pasta",
      "description": "Classic tomato pasta"
    },
    "spaghetti_bolognese": {
      "category": "pasta",
      "description": "Rich meat sauce pasta"
    },
    "spaghetti_marinara": {
      "category": "pasta",
      "description": "Traditional marinara sauce pasta"
    },
    "special_sauce": {
      "category": "sauces",
      "description": "Secret sauce blend"
    },
    "special_sauce_foam": {
      "category": "molecular",
      "description": "Foamed special sauce"
    },
    "stardust_cake": {
      "category": "exotic",
      "description": "Celestial dessert"
    },
    "stew": {
      "category": "meat",
      "description": "Hearty meat and potato stew"
    },
    "sweet_cream": {
      "category": "dairy",
      "description": "Sweetened cream base"
    },
    "sweet_milk": {
      "category": "dairy",
      "description": "Sweetened warm milk"
    },
    "sweet_pizza": {
      "category": "experimental",
      "description": "Dessert pizza creation"
    },
    "sweet_potato_madness": {
      "category": "experimental",
      "description": "Sweet and savory chaos"
    },
    "sweet_salty_combo": {
      "category": "experimental",
      "description": "Ice cream and fries"
    },
    "sweet_salty_fries": {
      "category": "experimental",
      "description": "Custard-dressed fries"
    },
    "sweet_savory_delight": {
      "category": "experimental",
      "description": "Three-way flavor fusion"
    },
    "toast_with_jam": {
      "category": "breads",
      "description": "Sweet breakfast classic"
    },
    "tomato_bread": {
      "category": "breads",
      "description": "Savory tomato-infused bread"
    },
    "tomato_foam": {
      "category": "molecular",
      "description": "Tomato-flavored foam"
    },
    "tomato_gelato": {
      "category": "experimental",
      "description": "Savory ice cream"
    },
    "tomato_juice": {
      "category": "sauces",
      "description": "Fresh tomato liquid"
    },
    "tomato_sauce": {
      "category": "sauces",
      "description": "Cooked tomato sauce"
    },
    "tomato_toast": {
      "category": "breads",
      "description": "Simple savory toast"
    },
    "toothpaste": {
      "category": "experimental",
      "description": "Mint paste creation"
    },
    "truffle_pasta": {
      "category": "gourmet",
      "description": "Luxurious truffle noodles"
    },
    "unicorn_dream_cake": {
      "category": "magical",
      "description": "Dreamy unicorn dessert"
    },
    "unicorn_latte": {
      "category": "exotic",
      "description": "Magical milk beverage"
    },
    "vanilla_panna_cotta": {
      "category": "gourmet",
      "description": "Silky vanilla dessert"
    },
    "wagyu_steak": {
      "category": "gourmet",
      "description": "Premium beef perfection"
    },
    "warm_milk": {
      "category": "dairy",
      "description": "Gently heated milk"
    },
    "whipped_cream": {
      "category": "dairy",
      "description": "Light and airy cream"
    }
  },
  "SERVING_AREA": {
    "BASE_ORDER_VALUE": 15,
    "INGREDIENT_BONUS": 3,
    "PAYOUT_DISPLAY_TIME": 5000,
    "PREMIUM_MULTIPLIER": 2,
    "WAITER_CHECK_INTERVAL": 1000,
    "WAITER_PICKUP_TIME": 5000
  },
  "SHOP": {
    "PREMIUM_COOKBOOK_COST": 250,
    "PREMIUM_COOKBOOK_UNLOCK_DAY": 5
  },
  "SHOP_ITEMS": {
    "caviar": {
      "category": "exotic",
      "cost": 138
    },
    "coconut": {
      "category": "exotic",
      "cost": 128
    },
    "crystal_salt": {
      "category": "magical",
      "cost": 150
    },
    "dragon_fruit": {
      "category": "magical",
      "cost": 155
    },
    "garlic": {
      "category": "premium_basic",
      "cost": 112
    },
    "herbs": {
      "category": "premium_basic",
      "cost": 115
    },
    "honey": {
      "category": "premium_basic",
      "cost": 116
    },
    "lemon": {
      "category": "premium_basic",
      "cost": 114
    },
    "moonwater": {
      "category": "magical",
      "cost": 160
    },
    "onion": {
      "category": "premium_basic",
      "cost": 110
    },
    "phoenix_egg": {
      "category": "magical",
      "cost": 170
    },
    "saffron": {
      "category": "exotic",
      "cost": 140
    },
    "spices": {
      "category": "premium_basic",
      "cost": 118
    },
    "stardust": {
      "category": "magical",
      "cost": 180
    },
    "truffle": {
      "category": "exotic",
      "cost": 135
    },
    "unicorn_milk": {
      "category": "magical",
      "cost": 165
    },
    "vanilla": {
      "category": "exotic",
      "cost": 125
    },
    "wagyu": {
      "category": "exotic",
      "cost": 132
    }
  },
  "SOUND_EFFECTS": {
    "COMBINATION_FAIL_VOLUME": 0.4,
    "COMBINATION_PAIR_VOLUME": 0.6,
    "COMBINATION_TRIPLE_VOLUME": 0.8,
    "SERVING_DROP_VOLUME": 0.7,
    "SETTINGS_TEST_VOLUME": 0.5
  },
  "SPLASH": {
    "backgroundColor": "#ffffff",
    "fadeOutDelayMs": 2500,
    "fadeOutDurationMs": 500,
    "fadeOutScaleTo": 0.8,
    "gridColor": "#334155",
    "gridDotSize": 1,
    "gridSpacing": 20,
    "imageCategory": "logos",
    "imageDisplayHeight": 192,
    "imageDisplayWidth": 192,
    "imageKey": "splash_logo",
    "popDurationMs": 700,
    "popOvershoot": 1.08,
    "popScaleFrom": 0.8,
    "popScaleTo": 1,
    "text": "Delichemy",
    "textColor": "#000000"
  },
  "TRIPLE_RECIPES": {
    "bread+herbs+oil": "enchanted_bread",
    "cheese+baked_potato": "loaded_potato",
    "cheese+chocolate+jam": "sweet_savory_delight",
    "cheese+cooked_meat+tomato_sauce": "lasagna_sauce",
    "cheese+meat+tomato": "meat_lovers_pizza",
    "cold_water+hot_oil": "foam",
    "cooked_meat+spaghetti_marinara": "spaghetti_bolognese",
    "dragon_fruit+phoenix_egg+unicorn_milk": "magical_feast",
    "egg+flour+milk": "batter",
    "fire+fresh_pasta+water": "cooked_pasta",
    "fire+fruit+sugar": "jam",
    "fire+milk+sugar": "caramel",
    "fire+oil+potato": "fries",
    "fire+potato+water": "mashed_potato",
    "fire+rice+water": "cooked_rice",
    "fruit+salt+water": "pickle",
    "ice+milk+sugar": "ice_cream",
    "meat+phoenix_egg+fire": "phoenix_fire_stew",
    "pasta+stardust+unicorn_milk": "celestial_pasta",
    "pastry+unicorn_milk+stardust": "unicorn_dream_cake",
    "pizza_base+phoenix_egg+dragon_fruit": "divine_pizza",
    "salt+sugar+tomato_juice": "ketchup"
  },
  "TUTORIAL": {
    "STEPS": [
      {
        "highlight": null,
        "text": "Let's learn the basics of culinary creation. Your journey to becoming a master chef starts now!",
        "title": "Welcome to Delichemy!"
      },
      {
        "highlight": null,
        "text": "The game operates on a 5-day weekly cycle. Today is a Recipe Creation Day - perfect for experimenting with new dishes!",
        "title": "Weekly Cycle"
      },
      {
        "highlight": {
          "height": "calc(100vh - 8rem)",
          "left": "1rem",
          "top": "4rem",
          "width": "380px"
        },
        "text": "This is your inventory. Only base ingredients appear here - you can drag any of these onto the workbench to start combining them.",
        "title": "Your Ingredients"
      },
      {
        "highlight": {
          "bottom": "1rem",
          "left": "400px",
          "right": "380px",
          "top": "4rem"
        },
        "text": "This is your workbench. Drop ingredients here and see what happens when they get close to each other!",
        "title": "The Workbench"
      },
      {
        "highlight": {
          "height": "calc(100vh - 8rem)",
          "right": "1rem",
          "top": "4rem",
          "width": "380px"
        },
        "text": "On customer serving days, you'll see orders on the right side. Complete dishes can be dropped in the serving area below the orders!",
        "title": "Orders & Serving"
      },
      {
        "highlight": null,
        "text": "Not everything is just pairs! Some dishes use 3 ingredients. And after you make a 2-ingredient recipe, try dropping that result next to a third ingredient to discover something new. In the cookbook, the ⚡ marker highlights advanced 3-ingredient recipes.",
        "title": "Some Recipes Need 3 Ingredients"
      },
      {
        "highlight": null,
        "text": "On Recipe Creation Days (Days 1 & 4), you can discover up to 10 new recipes. These recipes are saved to your cookbook for reference.",
        "title": "Recipe Creation Days"
      },
      {
        "highlight": null,
        "text": "On Customer Service Days (Days 2, 3 & 5), customers will place orders for recipes you've already discovered. You'll need to recreate them by combining ingredients! Don't worry - you're still encouraged to experiment and create new recipes during these days too!",
        "title": "Customer Service Days"
      },
      {
        "highlight": null,
        "text": "Discover 5 different recipes to complete the tutorial and advance to Day 2. Good luck, chef!",
        "title": "Your First Goal"
      }
    ]
  },
  "UI": {
    "SHOW_INSTRUCTIONS_FIRST_DAY_ONLY": true
  },
  "WEEKLY_CYCLE": {
    "CUSTOMER_SERVING_DAYS": [
      2,
      3,
      5
    ],
    "DAYS_PER_WEEK": 5,
    "DAY_TRANSITION_DISPLAY_MS": 3000,
    "FIRST_ORDER_DELAY_MS": 5000,
    "MAX_RECIPES_PER_CREATION_DAY": 10,
    "ORDERS_PER_SERVING_DAY": 8,
    "ORDER_INTERVAL_MAX_MS": 20000,
    "ORDER_INTERVAL_MIN_MS": 15000,
    "RECIPE_CREATION_DAYS": [
      1,
      4
    ],
    "TUTORIAL_RECIPES_TO_DISCOVER": 5
  },
  "WORKBENCH_HEIGHT": 800,
  "WORKBENCH_ITEM_SIZE": 64,
  "WORKBENCH_WIDTH": 1000,
  "ZOOM_SENSITIVITY": 0.001
};
